import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "2rem",
        borderRadius: ".75rem",
        minHeight: "11rem",
        transition: "all .3s ease-in-out",
        background: theme.palette.common.white,
        color: theme.palette.tailwind.slate[800],
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.08)",
        "&:hover": {
            cursor: "pointer",
            transform: "scale(1.02)",
        },
    },
    description: {
        lineHeight: "1.75",
        color: theme.palette.tailwind.gray[500],
    },
}))

type HelpCardProps = Readonly<{
    icon: IconProp
    title: string
    description?: string
    handleCardClick: () => void
}>

export const HelpCard = ({ icon, title, description, handleCardClick }: HelpCardProps) => {
    const { classes } = useStyles()

    return (
        <Stack gap="1rem" alignItems="start" className={classes.container} onClick={handleCardClick}>
            <FontAwesomeIcon icon={icon} size="2x" />

            <Stack gap=".5rem">
                <Typography variant="h6">{title}</Typography>
                {description && (
                    <Typography variant="body1" className={classes.description}>
                        {description}
                    </Typography>
                )}
            </Stack>
        </Stack>
    )
}
